import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  overrideAddEventListener,
  restoreAddEventListener,
  addDocumentClickListener,
} from "./ThomasEventsListeners";
import { ThomasRouteChangeEvent } from "./ThomasRouteChangeEvent";

/**
 * ThomasEventsWrapper component adds global event listeneners. This includes:
 * 1. Click tracking to all `button` and `a` tags
 * 1. Page view tracking when routing around on the SPA
 */
export const ThomasEventsWrapper: React.FC = ({
  children,
}): React.ReactElement => {
  const location = useLocation();

  useEffect(() => {
    const url = `${location.pathname}${location.search}`;
    const event = new ThomasRouteChangeEvent(url);
    event.emit();
  }, [location]);

  useEffect(() => {
    overrideAddEventListener();
    addDocumentClickListener();
    return () => {
      restoreAddEventListener();
    };
  }, []);

  return <>{children}</>;
};
